import decimalFieldProps from './decimalFieldProps';

export default decimalFieldProps;
